// extracted by mini-css-extract-plugin
export default {"Tooltip":"styles_Tooltip__xV5ed","visibleTooltip":"styles_visibleTooltip__vsdC7","note":"styles_note__ETKS8"};